import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { scrollToSection } from "@/hooks/useLenis";
import { useAuth } from "@/context/AuthContext";

const LINKS = [
  { label: "Manifesto", hash: "#manifesto", id: "nav-manifesto" },
  { label: "Work", hash: "#work", id: "nav-work" },
  { label: "Films", hash: "#films", id: "nav-films" },
  { label: "Collections", hash: "#collections", id: "nav-collections" },
  { label: "Stories", hash: "#stories", id: "nav-stories" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 0.9, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-[#0A0A0A]/85 backdrop-blur-md border-b border-white/5" : "bg-transparent"
      }`}
      data-testid="main-nav"
    >
      <nav className="flex items-center justify-between px-6 md:px-12 py-5">
        <button
          data-testid="nav-brand"
          onClick={() => window.__lenis?.scrollTo(0, { duration: 1.6 })}
          className="hover:opacity-70 transition-opacity duration-300"
        >
          <img src="/photos/logo-trimmed.webp" alt="TapeShift Wedding" className="h-7 md:h-8 w-auto" />
        </button>
        <div className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <button
              key={l.hash}
              data-testid={l.id}
              onClick={() => scrollToSection(l.hash)}
              className="text-xs tracking-[0.25em] uppercase text-[#A3A3A3] hover:text-[#C9A26B] transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid={user ? "nav-account-btn" : "nav-register-btn"}
            onClick={() => scrollToSection("#register")}
            className="text-xs tracking-[0.25em] uppercase border border-[#C9A26B]/60 px-5 py-2.5 text-[#C9A26B] hover:bg-[#C9A26B] hover:text-[#0A0A0A] transition-colors duration-400"
          >
            {user ? "My Account" : "Register"}
          </button>
          <button
            data-testid="nav-book-btn"
            onClick={() => scrollToSection("#book")}
            className="text-xs tracking-[0.25em] uppercase border border-[#C9A26B]/60 px-5 py-2.5 text-[#C9A26B] hover:bg-[#C9A26B] hover:text-[#0A0A0A] transition-colors duration-400"
          >
            Book Us
          </button>
        </div>
        <button
          data-testid="nav-book-btn-mobile"
          onClick={() => scrollToSection("#book")}
          className="md:hidden text-xs tracking-[0.25em] uppercase border border-white/30 px-4 py-2 text-[#F5F4F0]"
        >
          Book
        </button>
      </nav>
    </motion.header>
  );
};
